import Request from "./request";

const Project = "/projects";
const ProjecyCategories = "/projects/categories";
export default {
  async getProject(query) {
    return Request.get(
      Project,
      query
      // , {
      //   pageSize: query.pageSize,
      //   current: query.current,
      //   filters: {
      //     search: query.filters.search,
      //     type: query.filters.type,
      //     startDate: query.filters.startDate,
      //     endDate: query.filters.endDate,
      //     flagRecommend: query.filters.flagRecommend,
      //     status: query.filters.status,
      //     createTime: query.filters.createTime,
      //     closeTime: query.filters.closeTime,
      //     sorter: query.sorter
      //   }
      // }
    );
  },
  async getProjectId(id) {
    return Request.get(`${Project}/${id}`);
  },
  async getProjectRecomment(query) {
    return Request.get(Project, {
      pageSize: query.pageSize,
      current: query.current,
      filters: {
        flagRecommend: query.filters.flagRecommend,
        categoryId: query.filters.categoryId,
        relevance: query.filters.relevance
      }
    });
  },
  async getProjectCategoriesList(query) {
    return Request.get(Project, query);
  },
  async getProjectCategories(query) {
    return Request.get(ProjecyCategories, query);
  },
  async getProjectCategoriesDetail(id) {
    return Request.get(`${ProjecyCategories}/${id}`);
  },
  //我的项目
  async getProjectMine(query) {
    return Request.get(`${Project}/mine`, query);
  }
};
